var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48,6H8a4.993,4.993,0,0,0-4.975,5L3,41a5.015,5.015,0,0,0,5,5H48a5.015,5.015,0,0,0,5-5V11A5.015,5.015,0,0,0,48,6Zm0,35H8V16L28,28.5,48,16ZM28,23.5,8,11H48Z","transform":"translate(-3 -6)","fill":"#3b3b3b"}));
}

Email.defaultProps = {"width":"50","height":"40","viewBox":"0 0 50 40"};

module.exports = Email;

Email.default = Email;
